<template>
  <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
    <div class="bg-white rounded-lg p-6 w-3/4 max-w-4xl">
      <h3 class="text-lg font-semibold mb-2">Medikament (Freitext)</h3>
      <textarea v-model="medikament" class="w-full p-2 border rounded mb-4" rows="5" placeholder="Freitextverordnung"></textarea>
      <input v-model="darreichungsform" type="text" class="w-full p-2 border rounded mb-4" placeholder="Darreichungsform">
      <div class="flex justify-end">
        <button @click="$emit('close')" class="mr-2 px-4 py-2 bg-gray-200 rounded">Abbrechen</button>
        <button @click="submit" class="px-4 py-2 bg-blue-500 text-white rounded">Übernehmen</button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';

export default {
  name: 'FreitextModal',
  emits: ['close', 'submit'],
  setup(props, { emit }) {
    const medikament = ref('');
    const darreichungsform = ref('');

    const submit = () => {
      emit('submit', medikament.value, darreichungsform.value);
    };

    return {
      medikament,
      darreichungsform,
      submit
    };
  }
};
</script>